module.exports = __webpack_public_path__ + "media/images/expe_ioscor-2db5755d67723988744534234a8a6137.svg";